import { Link, useLocation, useNavigate } from "react-router-dom";
import { Zap, Flame, Coins, LogOut, Shield, Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import ThemeToggle from "./ThemeToggle";
import NotificationBell from "./NotificationBell";

const NAV = [
  { to: "/dashboard", label: "Home" },
  { to: "/tryouts", label: "Tryout" },
  { to: "/modules", label: "Modul" },
  { to: "/arena", label: "Arena" },
  { to: "/guilds", label: "Guild" },
  { to: "/mega", label: "Akbar" },
  { to: "/leaderboard", label: "Peringkat" },
  { to: "/pricing", label: "VIP" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-su-surface/80 border-b-2 border-su-border">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-3">
        <Link to="/dashboard" data-testid="navbar-logo" className="flex items-center gap-2 shrink-0">
          <img src="/brand/skorup_icon.png" alt="SkorUp.io" className="w-9 h-9 rounded-xl object-cover shadow-[0_3px_0_var(--su-primary-shadow)]" />
          <span className="font-heading font-black text-lg tracking-tight text-su-text hidden sm:block">
            SkorUp<span className="text-su-primary">.io</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => {
            const active = loc.pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={`px-4 py-2 rounded-xl font-heading font-extrabold text-sm transition-colors ${
                  active ? "bg-su-primary/10 text-su-primary" : "text-su-muted hover:text-su-text"
                }`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex items-center gap-1 font-heading font-extrabold text-sm text-su-energy" title="Energi">
            <Zap className="w-4 h-4 fill-current" /> {user?.energy ?? 0}
          </div>
          <div className="hidden sm:flex items-center gap-1 font-heading font-extrabold text-sm text-orange-500" title="Streak">
            <Flame className="w-4 h-4 fill-current" /> {user?.streak ?? 0}
          </div>
          <div className="hidden sm:flex items-center gap-1 font-heading font-extrabold text-sm text-su-secondaryShadow" title="Token">
            <Coins className="w-4 h-4" /> {user?.tokens ?? 0}
          </div>
          <ThemeToggle />
          <NotificationBell />
          <Link to="/pricing" data-testid="nav-vip-quick" className="w-10 h-10 rounded-full grid place-items-center border-2 border-su-border bg-su-surface hover:border-su-secondary transition-colors" title="VIP & Token">
            <Crown className="w-5 h-5 text-su-secondary" />
          </Link>
          {user?.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="w-10 h-10 rounded-full grid place-items-center border-2 border-su-border bg-su-surface" title="Admin">
              <Shield className="w-5 h-5 text-su-primary" />
            </Link>
          )}
          <button
            data-testid="navbar-logout"
            onClick={async () => { await logout(); nav("/"); }}
            className="w-10 h-10 rounded-full grid place-items-center border-2 border-su-border bg-su-surface hover:text-su-danger transition-colors"
            title="Keluar"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
